import { Box, Typography } from '@mui/material';
import { CopyableText } from 'src/components/data-grid-custom/copyable-text';
import Iconify from 'src/components/iconify';
import { LP_USER_LABELS } from './lp-users-table.utils';

export function LPUserTextCell({ value }: { value: unknown }) {
  const text = String(value ?? '');
  return (
    <CopyableText value={text} tooltipTitle={text}>
      <Typography variant="body2" noWrap>
        {text || '-'}
      </Typography>
    </CopyableText>
  );
}

export function LPUserTypeCell({ value }: { value: unknown }) {
  const type = String(value || '').toLowerCase();
  const icons: Record<string, string> = {
    exhibitor: 'solar:buildings-2-linear',
    shopkeeper: 'solar:shop-2-linear',
    contractor: 'solar:document-text-linear',
  };
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 1.2,
        py: 0.4,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'grey.300',
        backgroundColor: 'grey.100',
        color: 'text.primary',
        fontWeight: 600,
        minWidth: 110,
        textAlign: 'center',
      }}
    >
      <Iconify icon={icons[type] || 'solar:user-linear'} sx={{ width: 18, height: 18 }} />
      <Box component="span">{LP_USER_LABELS[type] || String(value || '-')}</Box>
    </Box>
  );
}
